// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"DealsPageNew_pageWrapper__WgWJB","container":"DealsPageNew_container__jgRMW"};